module.exports = __webpack_public_path__ + "static/media/raise.ed848c7d.svg";